import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/app/environments/environment';
import { Observable } from 'rxjs';
import { EbayOAuthResponse } from '../../Models/marketplaceAuthModel';

@Injectable({
  providedIn: 'root',
})
export class EbayAuthsService {
  baseUrl: string = environment.listerApiBaseUrl;

  constructor(private http: HttpClient) {}

  getAuthorizationUrl(AccountId: number): Observable<string> {
    const url = `${this.baseUrl}/EBayAuth/AuthorizationUrl?accountId=${AccountId}&isSandbox=false`;
    return this.http.get<string>(url);
  }
  exchangeCode(Code: string): Observable<EbayOAuthResponse> {
    const url = `${this.baseUrl}/EBayAuth/ExchangeCode?code=${Code}&isSandbox=false`;
    return this.http.get<EbayOAuthResponse>(url);
  }
}
